import instance from "@/utils/require.js"

// 包装工单--分页查询
export function apiCartonOrderSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/search",
		method: "post",
		data
	})
}

// 包装工单--新建包装工单
export function apiCartonOrderAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/add",
		method: "post",
		data
	})
}

// 包装工单--客户列表
export function apiCustomerList(data = {}) {
	return instance({
		url: "/aim/api/v3/customer/list",
		method: "post",
		data
	})
}

// 包装工单--产品类别列表
export function apiProductTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/product_type",
		method: "post",
		data
	})
}

// 包装工单--产品型号列表
export function apiProductList(data = {}) {
	return instance({
		url: "/aim/api/v3/product/list",
		method: "post",
		data
	})
}

// 包装工单--包装类型列表
export function apiCartonTypeList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/carton_type",
		method: "post",
		data
	})
}

// 包装工单--混装比例列表
export function apiCartonScaleList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/carton_scale",
		method: "post",
		data
	})
}

// 工单详情--数据查询
export function apiCartonOrderDetail(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/detail",
		method: "post",
		data
	})
}

// 工单详情--开始生产
export function apiCartonOrderStart(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/start",
		method: "post",
		data
	})
}

// 工单详情--结单
export function apiCartonOrderClose(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/close",
		method: "post",
		data
	})
}

// 工单详情--重新打开
export function apiCartonOrderReopen(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/reopen",
		method: "post",
		data
	})
}

// 工单详情--修改开始包装时间
export function apiUpdateStartDateTime(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_start_date_time",
		method: "post",
		data
	})
}

export function apiUpdateCustomerPo(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_customer_po",
		method: "post",
		data
	})
}
// 工单详情--工单号
export function apiUpdateOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_order_number",
		method: "post",
		data
	})
}
// 工单详情--修改SAP单号
export function apiUpdateSapOrderNumber(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_sap_order_number",
		method: "post",
		data
	})
}
// 工单详情--修改国家码
export function apiUpdateCountryCode(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_country_code",
		method: "post",
		data
	})
}
// 工单详情--修改备注
export function apiUpdateNotes(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_notes",
		method: "post",
		data
	})
}
// 工单详情--修改成品编码
export function apiUpdateItemCode(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_item_code",
		method: "post",
		data
	})
}

// 产品列表--绑定MAC
export function apiCartonOrderBindPackageFid(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/bind_package",
		method: "post",
		data
	})
}

// 工单详情--设置主组装工单
export function apiCartonOrderSetPrimary(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/set_primary",
		method: "post",
		data
	})
}

// 工单详情--删除组装工单
export function apiCartonOrderRemoveOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/remove_production_order",
		method: "post",
		data
	})
}

// 工单详情--添加组装工单
export function apiCartonOrderAddOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/add_production_order",
		method: "post",
		data
	})
}

// 工单详情--修改包装规格
export function apiUpdateCartonSpec(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_carton_spec",
		method: "post",
		data
	})
}
// 工单详情--修改QC设置信息
export function apiUpdateQC(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_qc",
		method: "post",
		data
	})
}

// 产品列表--表格查询
export function apiCartonOrderDevices(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/devices",
		method: "post",
		data
	})
}

// 产品列表--组装工单下拉
export function apiCartonOrderProductionOrders(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/production_orders",
		method: "post",
		data
	})
}

// 产品列表--当前工序下拉
export function apiProductionOrderStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/status_list",
		method: "post",
		data
	})
}
// 交接工单
export function apiHandoverOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/handover",
		method: "post",
		data
	})
}
// 修改工单数量
export function apiCartonOrderUpdateQuantity(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/update_quantity",
		method: "post",
		data
	})
}

// 产品列表--解绑
export function apiUnbindOuterCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/outer_carton",
		method: "post",
		data
	})
}

// 产品列表--解绑
export function apiUnbindInnerCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/inner_carton",
		method: "post",
		data
	})
}

// 产品列表--解绑
export function apiUnbindPalletCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/pallet",
		method: "post",
		data
	})
}

// 产品列表--产品生命周期
export function apiDeviceLife(data = {}) {
	return instance({
		url: "/aim/api/v3/device/life",
		method: "post",
		data
	})
}

// 生产状态--工序状态
export function apiCartonOrderWorkStation(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/reportByProductionOrder/by_work_station",
		method: "post",
		data
	})
}

// 生产状态--工单状态
export function apiCartonOrderOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/reportByProductionOrder/by_production_order",
		method: "post",
		data
	})
}

// 生产状态--产品状态
export function apiCartonByDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/reportByProductionOrder/by_device",
		method: "post",
		data
	})
}

// 生产工序--表格Sop
export function apiCartonSopSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/search",
		method: "post",
		data
	})
}

// 生产工序--新增sop
export function apiCartonSopAdd(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/add",
		method: "post",
		data
	})
}

// 生产工序--修改sop
export function apiCartonSopUpdate(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/update",
		method: "post",
		data
	})
}

// 生产工序--禁用sop
export function apiCartonSopDisable(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/disable",
		method: "post",
		data
	})
}

// 生产工序--启用sop
export function apiCartonSopEnable(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/enable",
		method: "post",
		data
	})
}

// 生产工序--删除sop
export function apiCartonSopDelete(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/delete",
		method: "post",
		data
	})
}

// 生产工序--下移sop
export function apiCartonSopMoveDown(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/move_down",
		method: "post",
		data
	})
}

// 生产工序--上移sop
export function apiCartonSopMoveUp(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/move_up",
		method: "post",
		data
	})
}

// 拖拽排序
export function apiCartonSopDragSort(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/drag_sort",
		method: "post",
		data
	})
}

// 生产工序--工序下拉
export function apiWorkStationList(data = {}) {
	return instance({
		url: "/aim/api/v3/factory_setting/work_station/list",
		method: "post",
		data
	})
}

// 生产工序--上一工序下拉
export function apiCartonSopList(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/sop/list",
		method: "post",
		data
	})
}

// 生产工序--标签类型下拉
export function apiLabelType(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/label_type",
		method: "post",
		data
	})
}

// 生产工序--局胜制下拉
export function apiBestOf(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/best_of",
		method: "post",
		data
	})
}
// 包装工单中移除产品
export function apiCartonOrderRemoveDevice(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/remove_device",
		method: "post",
		data
	})
}
// 包装工单中移除产品
export function apiCartonOrderRemoveDevices(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/remove_devices",
		method: "post",
		data
	})
}
// 包装工单中移除未封箱的产品
export function apiCartonOrderRemoveUnpacked(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/remove_unpacked",
		method: "post",
		data
	})
}
export function apiReworkByCartonOrder(data = {}) {
	return instance({
		url: "/aim/api/v3/rework/by_carton_order",
		method: "post",
		data
	})
}
export function apiMultipleUnbindInnerCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/multiple/inner_carton",
		method: "post",
		data
	})
}
export function apiMultipleUnbindOuterCarton(data = {}) {
	return instance({
		url: "/aim/api/v3/factory/unbind/multiple/outer_carton",
		method: "post",
		data
	})
}


// 包装工单--工单状态列表
export function apiOrderStatusList(data = {}) {
	return instance({
		url: "/aim/api/v3/enum/order_status",
		method: "post",
		data
	})
}

// 包装工单--锁定
export function apiCartonOrderLock(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/lock",
		method: "post",
		data
	})
}

// 包装工单--解锁
export function apiCartonOrderUnlock(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/unlock",
		method: "post",
		data
	})
}

// 包装工单--解锁
export function apiCartonOrderPause(data = {}) {
	return instance({
		url: "/aim/api/v3/carton_order/pause",
		method: "post",
		data
	})
}
